var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        }
      },
      model: {
        value: _vm.valid,
        callback: function($$v) {
          _vm.valid = $$v
        },
        expression: "valid"
      }
    },
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            {
              staticClass: "pa-0",
              staticStyle: { "min-width": "100%" },
              attrs: { "grid-list-md": "" }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "text-field-reducido-border",
                        attrs: {
                          rules: _vm.$validate(["required"]),
                          required: "",
                          label: "Fecha de retiro",
                          type: "date",
                          outline: ""
                        },
                        model: {
                          value: _vm.form.fecha_inicio,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fecha_inicio", $$v)
                          },
                          expression: "form.fecha_inicio"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-actions",
        [
          _c("small", { staticClass: "error--text text-required" }, [
            _vm._v("* Los campos son obligatorios *")
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [
              _c("v-icon", [_vm._v("cancel")]),
              _vm._v(" " + _vm._s(_vm.$t("common.cancel")) + "\n    ")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.fecha_futuro,
                  expression: "!fecha_futuro"
                }
              ],
              attrs: {
                color: "primary",
                type: "submit",
                disabled: !_vm.valid,
                loading: _vm.loading
              }
            },
            [
              _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
              _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-041799a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-041799a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/movilidad/components/RetiroPasante.vue
// module id = null
// module chunks = 